import React, { useCallback, useEffect, useRef, useState } from 'react';
import Footer from './Footer';
import styles from './ProjectEmbed.module.css';

const ProjectEmbed = ({ src, title }) => {
    const [height, setHeight] = useState(900);
    const observerRef = useRef(null);
    const wheelCleanupRef = useRef(null);

    useEffect(() => () => {
        observerRef.current?.disconnect();
        wheelCleanupRef.current?.();
    }, []);

    const handleLoad = useCallback((event) => {
        const iframe = event.currentTarget;
        const document = iframe.contentDocument;
        const scrollContainer = iframe.parentElement;

        if (!document || !scrollContainer) return;

        const updateHeight = () => {
            const nextHeight = Math.max(
                document.documentElement.scrollHeight,
                document.body?.scrollHeight || 0
            );
            setHeight(nextHeight);
        };

        observerRef.current?.disconnect();
        observerRef.current = new ResizeObserver(updateHeight);
        observerRef.current.observe(document.documentElement);
        updateHeight();

        // The iframe is expanded to its full content height, so it has nowhere
        // to scroll itself. Forward wheel/trackpad momentum to the Page scroller
        // instead of relying on inconsistent scroll chaining across the iframe.
        const forwardWheel = (wheelEvent) => {
            if (wheelEvent.ctrlKey) return;

            const deltaScale = wheelEvent.deltaMode === WheelEvent.DOM_DELTA_LINE
                ? 16
                : wheelEvent.deltaMode === WheelEvent.DOM_DELTA_PAGE
                    ? scrollContainer.clientHeight
                    : 1;

            wheelEvent.preventDefault();
            scrollContainer.scrollBy({
                left: wheelEvent.deltaX * deltaScale,
                top: wheelEvent.deltaY * deltaScale,
                behavior: 'auto',
            });
        };

        wheelCleanupRef.current?.();
        document.addEventListener('wheel', forwardWheel, { passive: false });
        wheelCleanupRef.current = () => {
            document.removeEventListener('wheel', forwardWheel);
        };
    }, []);

    return (
        <div className="Page">
            <iframe
                className={styles.projectFrame}
                src={src}
                title={title}
                style={{ height }}
                onLoad={handleLoad}
            />
            <Footer />
        </div>
    );
};

export default ProjectEmbed;
